import {
  BiCreditCard,
  BiGroup,
  BiSearch,
} from "react-icons/bi";
import { ImFileText2 } from "react-icons/im";
import { RiDashboardLine } from "react-icons/ri";
import { HiOutlineShieldCheck } from "react-icons/hi";
import {
  HiOutlineCash,
  HiOutlineChartBar,
  HiOutlineClipboardList,
  HiOutlineDocumentText,
  HiOutlineOfficeBuilding,
  HiOutlineSparkles,
  HiOutlineTag,
  HiOutlineUserAdd,
  HiOutlineVideoCamera,
  HiOutlineCalendar,
} from "react-icons/hi";
import { MdOutlineManageAccounts } from "react-icons/md";

export const SuperAdminNavigationSections = [
  {
    id: "overview",
    label: "Overview",
    items: [
      {
        name: "Dashboard",
        icon: RiDashboardLine,
        to: "/dashboard",
        platformPermission: "platform.dashboard.view",
      },
    ],
  },
  {
    id: "tenants",
    label: "Tenants",
    items: [
      {
        name: "All tenants",
        icon: HiOutlineOfficeBuilding,
        to: "/tenants",
        matchPrefixes: ["/tenants"],
        platformPermission: "platform.tenant.list",
      },
      {
        name: "Prospects",
        icon: HiOutlineUserAdd,
        to: "/prospects",
        platformPermission: "platform.prospect.list",
      },
    ],
  },
  {
    id: "users",
    label: "Users",
    items: [
      {
        name: "Search users",
        icon: BiSearch,
        to: "/users",
        platformPermission: "platform.user.search",
      },
      {
        name: "Platform staff",
        icon: BiGroup,
        to: "/staff-users",
        platformPermission: "platform.staff.list",
      },
      {
        name: "Platform roles",
        icon: HiOutlineShieldCheck,
        to: "/platform-roles",
        platformPermission: "platform.roles.manage",
      },
    ],
  },
  {
    id: "governance",
    label: "Governance",
    items: [
      {
        name: "Audit log",
        icon: ImFileText2,
        to: "/audit-log",
        platformPermission: "platform.audit.view",
      },
      {
        name: "Ghost sessions",
        icon: MdOutlineManageAccounts,
        to: "/ghost-sessions",
        platformPermission: "platform.ghost.end",
      },
    ],
  },
  {
    id: "catalog",
    label: "Catalog",
    items: [
      {
        name: "Forms — CRM",
        icon: HiOutlineDocumentText,
        to: "/forms-list",
        matchPrefixes: ["/forms-list", "/crm"],
        platformPermission: "platform.catalog.forms",
      },
      {
        name: "Forms — HRM",
        icon: HiOutlineClipboardList,
        to: "/forms-list-hrm",
        matchPrefixes: ["/forms-list-hrm", "/hrm"],
        platformPermission: "platform.catalog.forms",
      },
      {
        name: "Feature of the Week",
        icon: HiOutlineVideoCamera,
        to: "/platform/feature-of-the-week",
        platformPermission: "platform.catalog.news",
      },
      {
        name: "Events",
        icon: HiOutlineCalendar,
        to: "/platform/events",
        platformPermission: "platform.catalog.news",
      },
    ],
  },
  {
    id: "commercial",
    label: "Commercial",
    items: [
      {
        name: "Financial overview",
        icon: HiOutlineCash,
        to: "/billing",
        platformPermission: "platform.billing.view",
      },
      {
        name: "Plans",
        icon: HiOutlineTag,
        to: "/plans",
        matchPrefixes: ["/plans"],
        platformPermission: "platform.plans.manage",
      },
      {
        name: "Stripe management",
        icon: BiCreditCard,
        to: "/stripe",
        platformPermissions: ["platform.plans.manage", "platform.billing.view"],
      },
    ],
  },
  {
    id: "analytics",
    label: "Analytics",
    items: [
      {
        name: "Feature usage",
        icon: HiOutlineChartBar,
        to: "/usage",
        platformPermission: "platform.usage.view",
      },
      {
        name: "AI Usage",
        icon: HiOutlineSparkles,
        to: "/ai-usage",
        platformPermission: "platform.ai_usage.view",
      },
    ],
  },
];

/** @deprecated Use SuperAdminNavigationSections — kept for tests importing flat list */
export const SuperAdminNavigation = SuperAdminNavigationSections.flatMap(
  (section) => section.items
);
